export default {
  driver_performance_events_assingDriver_driver: "Conductor",
  driver_performance_events_assingDriver_selectDriver: "Seleccionar conductor",
  driver_performance_events_assingDriver_title: "Actualizar conductor asignado",
};